/*export const config = {
  AWS_ACCESS_KEY_ID: 'AKIAVH7UWBZPEU3ELXIX',
  AWS_SECRET_KEY: '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',
  BUCKET_NAME: 'abc-videos',
  REGION: 'sa-east-1',
  endpoint: 's3-accelerate.amazonaws.com',
}*/

export const config = {
  AWS_ACCESS_KEY_ID: 'AKIAVH7UWBZPPC6QQ4NU',
  AWS_SECRET_KEY: '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',
  BUCKET_NAME: 'abc-videos',
  REGION: 'sa-east-1',
  endpoint: 's3-accelerate.amazonaws.com',
};

//export const baseUrl = 'http://localhost:4444'
//export const baseUrl = 'https://localhost:8443'
export const baseUrl = 'https://api.academiabrasileiradecinema.com.br'
